// extracted by mini-css-extract-plugin
module.exports = {"badge":"_3qT-E","primary":"_2ss6-","lightPrimary":"_2r1xK","darkGrey":"_2wGOK","grey":"o5Nih","secondary":"_2fWNK","red":"_2uw64","lightGrey":"_2DwbE","yellow":"_3o1Y2"};